import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CollectionResource } from '@app/data/resources';
import { QuotaUsageFilterInput } from './inputs';
import { QuotaUsageResource } from './resources';

export default class QuotaUsage {
    private basePath = '/api/quota-usage';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get quota usage for user
    get = async (userId: ID, filter: QuotaUsageFilterInput): Promise<CollectionResource<QuotaUsageResource, {}>> => {
        const query = qs.stringify({ ...filter });

        const { data } = await this.http.get(`${this.basePath}/user-space/${userId}?${query}`);

        return data;
    };
}
